import {ReactElement} from 'react';
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

interface DownloadIconProps {
    tooltip: string | ReactElement;
}
const DownloadIcon = ({tooltip}: DownloadIconProps): JSX.Element => {
    return (
        <OverlayTrigger overlay={<Tooltip>{tooltip}</Tooltip>} placement={'top'}>
            <i className="fs-1 fa-solid fa-download"></i>
        </OverlayTrigger>
    );
};

export default DownloadIcon;
